export default __webpack_public_path__ + "static/media/slide6.eb69c109.jpg";